import React, { useState } from "react";
import { ConsumptionKpiCards } from "./KpiCard";
import { ConsumptionChart } from "./ConsumptionChart";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@shared/ui/select";
import { Droplet } from "lucide-react";
import { useTranslation } from "react-i18next";

export const ConsumptionView = () => {
  const { t } = useTranslation();
  const [period, setPeriod] = useState("6_months");
  const [utility, setUtility] = useState("water");

  return (
    <div className="space-y-6 pt-4">
      <div className="flex items-center justify-end gap-3 mb-2">
        <Select value={period} onValueChange={setPeriod}>
          <SelectTrigger className="w-auto  ">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="1_month">{t("1 Month")}</SelectItem>
            <SelectItem value="3_months">{t("3 Months")}</SelectItem>
            <SelectItem value="6_months">{t("6 Months")}</SelectItem>
            <SelectItem value="1_year">{t("1 Year")}</SelectItem>
          </SelectContent>
        </Select>

        <Select value={utility} onValueChange={setUtility}>
<SelectTrigger className="w-auto  ">
              <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="water">
              <div className="flex items-center gap-2">
                <span className="text-blue-400 drop-shadow-sm text-base">💧</span>
                <span>{t("Water")}</span>
              </div>
            </SelectItem>
            <SelectItem value="electricity">
              <div className="flex items-center gap-2">
                <span className="text-yellow-400 drop-shadow-sm text-base">⚡</span>
                <span>{t("Electricity")}</span>
              </div>
            </SelectItem>
          </SelectContent>
        </Select>
      </div>

      <ConsumptionKpiCards />
      <ConsumptionChart />
    </div>
  );
};
